import T from '@wojtekmaj/react-t';

import CheckboxField from '@rewardopl/react-ui/checkbox_field';

import { Indent, Wrapper } from './marketing_controls.styles';

type MarketingControlsProps = {
  marketingAccepted: boolean;
  marketingEmailAccepted: boolean;
  marketingSmsAccepted: boolean;
  setMarketingEmailAccepted: React.Dispatch<React.SetStateAction<boolean>>;
  setMarketingSmsAccepted: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function MarketingControls({
  marketingAccepted,
  marketingEmailAccepted,
  marketingSmsAccepted,
  setMarketingEmailAccepted,
  setMarketingSmsAccepted,
}: MarketingControlsProps) {
  return (
    <Wrapper>
      <CheckboxField
        checked={marketingAccepted}
        label={
          <T>
            I consent to Salad Story S.A. providing information about the latest promotions,
            products and services of its own and about the promotions, products and services of its
            partners via e-mail or push messages.
          </T>
        }
        name="marketing_accepted"
        onChange={() => {
          setMarketingEmailAccepted(!marketingAccepted);
          setMarketingSmsAccepted(!marketingAccepted);
        }}
      />
      <Indent>
        <CheckboxField
          checked={marketingSmsAccepted}
          label={<T>SMS</T>}
          name="marketing_sms_accepted"
          onChange={() => {
            setMarketingSmsAccepted(!marketingSmsAccepted);
          }}
        />
        <CheckboxField
          checked={marketingEmailAccepted}
          label={<T>E-mail</T>}
          name="marketing_email_accepted"
          onChange={() => {
            setMarketingEmailAccepted(!marketingEmailAccepted);
          }}
        />
      </Indent>
    </Wrapper>
  );
}
